import WiretapApp from 'bam-wiretap/WiretapApp';
import feedJson from './configs/feed-headline-tracking.json';

/**
 * Set the variables inside the tracking event object.
 * Should be overridden by the custom section implementations.
 * @param  {object} trackObj Config properties.
 * @param  {jquery} $el      The jquery event element.
 */

const setCustomTrackingVars = function (trackObj, $el) {
    const pageMeta = window.pageMeta;
    const { siteName, page_section, page_name } = pageMeta;

    // Replace any variables within each prop value.
    $.each(trackObj, (prop, val) => {
        let value = val.toString();

        if (value.indexOf('@') !== -1) {
            if (value.match(/@SITENAME@/)) {
                value = value.replace(/@SITENAME@/, siteName);
            }
            if (value.match(/@PAGESECTION@/)) {
                value = value.replace(/@PAGESECTION@/, page_section);
            }
            if (value.match(/@PAGENAME@/)) {
                value = value.replace(/@PAGENAME@/, page_name);
            }
            if (value.match(/@FEEDCONTENTTYPE@/)) {
                value = value.replace(/@FEEDCONTENTTYPE@/, $el.attr('data-content-type') || $el.attr('data-type'));
            }
            if (value.match(/@FEEDCONTENTINDEX@/)) {
                value = value.replace(/@FEEDCONTENTINDEX@/, $el.index());
            }
            if (value.match(/@HEADLINEINDEX@/)) {
                value = value.replace(/@HEADLINEINDEX@/, $el.parent().attr('data-index'));
            }

            trackObj[prop] = value;
        }

        // Remove any bad props.
        if (trackObj[prop] === 'undefined' || trackObj[prop] === null) {
            delete trackObj[prop];
        }
    });

    return trackObj;
};

export default new WiretapApp(feedJson, setCustomTrackingVars, {});
